import type { FeedbackItem } from '../lib/api.ts'
import { describeFeedback } from '../lib/feedbackItem.ts'
import { checkSides } from '../lib/verificationItems.ts'
import { CHECK_LABEL, label } from '../lib/vocabulary.ts'
import { TriageControls } from './TriageControls.tsx'

export function FeedbackContext({
  item,
  draftNote,
  busy,
  onDraftChange,
  onSave,
  onClear,
}: {
  item: FeedbackItem
  draftNote: string
  busy: boolean
  onDraftChange: (note: string) => void
  onSave: (verdict: string, note: string) => Promise<void>
  onClear: () => Promise<void>
}) {
  const said = describeFeedback(item)
  const check = item.detail?.check
  const sides =
    check === undefined
      ? undefined
      : checkSides({ check, evidence: item.detail?.evidence ?? {} } as never)
  return (
    <div className="flex flex-col gap-3">
      <div className="text-tSmall text-text-weak flex flex-col gap-1">
        <p className="text-text-strong font-semibold">{item.account_name}</p>
        <p>
          Filial {item.branch_code} · Orçamento {item.quotation_number}
        </p>
        <p>
          {item.actor_email} · {new Date(item.at).toLocaleString('pt-BR')}
        </p>
      </div>
      {check !== undefined && (
        <div className="flex flex-col gap-1">
          <p className="text-tPSemi text-text-strong">
            {label(CHECK_LABEL, check)}
            {item.ruleTitle === undefined ? '' : ` · ${item.ruleTitle}`}
          </p>
          {item.detail?.message !== undefined && (
            <p className="text-tSmall text-text-weak">{item.detail.message}</p>
          )}
          {sides !== undefined &&
            (sides.prescribed !== undefined || sides.quoted !== undefined) && (
              <p className="text-tSmall text-text-weak">
                Receita no feedback: {sides.prescribed ?? '—'} · Orçamento no feedback:{' '}
                {sides.quoted ?? '—'}
              </p>
            )}
        </div>
      )}
      <p className="text-tPSemi text-text-strong">
        {said.answer}
        {said.reason === undefined ? '' : ` · ${said.reason}`}
      </p>
      {said.note !== undefined && (
        <blockquote className="border-stroke-weak text-tP text-text-strong break-words border-l-2 pl-3">
          {said.note}
        </blockquote>
      )}
      <p className="text-tSmall text-text-weak">
        A comparação ao lado mostra a última análise armazenada.
      </p>
      <div className="border-stroke-weak border-t pt-3">
        <TriageControls
          key={`${item.id}:${item.verdict ?? ''}:${item.triaged_at ?? ''}`}
          claim={item.claim}
          verdict={item.verdict}
          note={item.triage_note}
          by={item.triaged_by}
          at={item.triaged_at}
          draftNote={draftNote}
          onDraftChange={onDraftChange}
          disabled={busy}
          onSave={onSave}
          onClear={onClear}
        />
      </div>
    </div>
  )
}
